import icons from '../../config/icons.config'
import { useDeleteActivityLog } from '../../hooks/activity/useDeleteActivityLog'
import { useUser } from '../../hooks/user/useUser'
import useConfirm from '../../hooks/util/useConfirm'
import type { ActivityFeedItem } from '../../logic/activityFeed'
import AppIcon from '../icons/AppIcon'
import Avatar from '../primitives/Avatar'
import IconButton from '../primitives/IconButton'
import styles from './ActivityFeed.module.css'

interface ActivityFeedProps {
  items: ActivityFeedItem[]
}

export default function ActivityFeed({ items }: ActivityFeedProps) {
  const { data: currentUser } = useUser()
  const { mutate: deleteActivityLog } = useDeleteActivityLog()
  const confirm = useConfirm()

  function handleDelete(logID: string) {
    confirm({
      title: 'Delete activity log',
      message: 'Are you sure? This cannot be undone.',
      confirmation: 'Delete',
      onConfirm: () => deleteActivityLog(logID),
    })
  }

  if (items.length === 0) {
    return <p className={styles.empty} data-testid="activity-feed-empty">
        Your team hasn&apos;t logged any activities yet
      </p>
  }

  return (
    <div className={styles.feed} data-testid="activity-feed">
      {items.map((item) => (
        <div key={item.id} className={styles.item} data-testid="activity-feed-item">
          <Avatar initials={item.initials} photoUrl={item.photoUrl} size="sm" />
          <div className={styles.text}>
            <b>{item.name}</b> {item.message}
            <span className={styles.time}>{item.time}</span>
          </div>
          <div className={styles.rm}>
            {item.isBadge ? (
              <AppIcon icon={icons.trophy} size={18} className={styles.star} />
            ) : (
              <>
                +{item.rms}
                <span className={styles.rmUnit}>RMs</span>
              </>
            )}
          </div>
          {!item.isBadge && item.userID === currentUser?.id && (
            <IconButton title="Delete activity" onClick={() => handleDelete(item.id)}>
              <AppIcon icon={icons.x} size={18} />
            </IconButton>
          )}
        </div>
      ))}
    </div>
  )
}
